import type { Order } from "../Order.js";

export function getWeightInGramsOfOrder(order: Pick<Order, "products">): number {
	return order.products.reduce((total, product) => total + product.info.variant.weightInGrams * product.quantity, 0);
}
